import { Text } from "@ds/react";
import styled from "styled-components/macro";

export const StyleTitle = styled(Text)(({ theme }) => ({
  fontSize: "18px",
  color: theme.color.neutral["02"],
  fontWeight: 400,
  marginBottom: "12px",
  margin: "0px",

  [theme.breakpoint.lg()]: {
    lineHeight: "32px",
    fontSize: "20px",
  },

  "&.small": {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "1",
  },
}));

export const ContainerDados = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: {
    margin: "0px",
  },
  svg: {
    color: theme.color.brandPrimary.light,
  },
}));

export const ContentDados = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const StyleTextDadosTitulo = styled(Text)(({ theme }) => ({
  fontSize: "12px",
  color: theme.color.neutral["02"],
  lineHeight: "20px",
  fontWeight: 700,

  [theme.breakpoint.lg()]: {
    fontSize: "14px",
  },

  "&.small": {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "1",
  },
}));

export const StyleTextDadosPessoaisSmall = styled(Text)(({ theme }) => ({
  color: theme.color.neutral["03"],
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 500,
  marginBottom: "4px",

  [theme.breakpoint.lg()]: {},

  "&.small": {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "1",
  },
}));

export const StyleTextDadosPessoais = styled(Text)(({ theme }) => ({
  fontSize: "12px",
  color: theme.color.neutral["02"],
  lineHeight: "21px",
  fontWeight: 400,

  [theme.breakpoint.lg()]: {
    fontSize: "16px",
    lineHeight: "24px",
  },

  "&.small": {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "1",
  },
}));

export const Frame = styled.iframe(({ height }) => ({
  width: "100%",
  height,
  border: 0,
  overflow: "hidden",
}));
